import { useEffect } from 'react' 
import { useSelector } from 'react-redux';

const CustomHook = (refTab = null, refList = null) => {
  const scrollTab = refTab;
  const divs = refList;
  const activeTab = useSelector(state => state.activeTab.toLowerCase());

  useEffect(() => {
    if (scrollTab.current.classList.contains(activeTab)) {
      const componentNode = scrollTab.current;
      const offsetTop = componentNode.offsetTop;
      const duration = 500; // adjust the duration to your liking
      const startTime = Date.now();
      const scrollPosition = window.scrollY;

      function animateScroll() {
        const elapsed = Date.now() - startTime;
        const progress = elapsed / duration;
        const newScrollPosition = scrollPosition + (offsetTop - scrollPosition) * progress;

        window.scrollTo(0, newScrollPosition);

        if (elapsed < duration) {
          requestAnimationFrame(animateScroll);
        }
      }

      animateScroll();
    }
    if (divs !== null) {
      divs.current.forEach((div) => {
        div.classList.add('animation');
      });
      const handlScroll = () => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;
        // If at (or near) bottom, activate all
        if (windowHeight + scrollPosition >= docHeight - 10) {
          divs.current.forEach((div) => div.classList.add('active'));
          return;
        }
        divs.current.forEach((div) => {
          const offsetTop = div.getBoundingClientRect().top + scrollPosition;
          if (scrollPosition >= offsetTop - (window.innerHeight / (1.5))) {
            div.classList.add('active');
          } else {
            div.classList.remove('active');
          }
        });
      }
      window.addEventListener('scroll', handlScroll);
      // Also run once on mount in case already at bottom
      handlScroll();
      // Clean up
      return () => window.removeEventListener('scroll', handlScroll);
    }
  }, [activeTab, divs, scrollTab])
}

export default CustomHook